import React, { useState } from 'react';
import '../styles/Hero.css';

const Hero = () => {
  const [enlargedImage, setEnlargedImage] = useState(null);
  
  // const handleImageClick = (imageSrc) => {
  //   if (enlargedImage === imageSrc) {
  //     // 如果點擊的是已經放大的圖片，則縮小
  //     setEnlargedImage(null);
  //   } else {
  //     // 否則，放大該圖片
  //     setEnlargedImage(imageSrc);
  //   }
  // };
  
  // const images = [
  //   require('../images/hero-1.jpg'),
  //   require('../images/hero-2.jpg'),
  //   require('../images/hero-3.jpg')
  // ];

  return (
    <section className="hero" id="hero-section">
      {/* <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">聯漢室內設計</h1>
          <p className="hero-description">
            專業室內設計團隊，創造有溫度的家居空間
          </p>
          <div className="hero-cta">
            <a href="#contact" className="cta-button">聯絡我們</a>
            <a href="#projects" className="cta-button secondary">查看作品</a>
          </div>
          <div className="hero-showcase">
            {images.map((image, index) => (
              <div 
                key={index} 
                className={`showcase-item ${enlargedImage === image ? 'enlarged' : ''}`}
                onClick={() => handleImageClick(image)}
              >
                <img src={image} alt={`室內設計作品展示 ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </div> */}
      
      {enlargedImage && (
        <div className="image-modal" onClick={() => setEnlargedImage(null)}>
          <div className="modal-content">
            <img src={enlargedImage} alt="放大的設計作品" />
            <button className="close-modal" onClick={() => setEnlargedImage(null)}>×</button>
          </div>
        </div>
      )}
    </section>
  );
}

export default Hero; 